import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Mode, applyMode } from '@cloudscape-design/global-styles';

import HomePage from './home';
import ErrorPage from './error';

import '@cloudscape-design/global-styles/index.css';
import './global.css';

function App() {
  useEffect(() => {
    applyMode(Mode.Dark);
  }, []);

  return (
    <Routes>
      <Route element={<ErrorPage />} path="*" />
      <Route element={<HomePage />} path="/" />
    </Routes>
  );
}

export default App;
